// Modules
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Intent, NonIdealState } from '@blueprintjs/core'

// Components
import Page from 'components/layout/page/Page'

// Hooks
import useLanguage from 'hooks/system/useLanguage'

// Helpers
import { getFullPath } from 'helpers/route'

// Styles
import './Message.scss'

// Section: Error > Landing > Message
function Message () {
	// Data
	const navigate = useNavigate()
	const { translate } = useLanguage('pages.error.views.landing.sections.message')

	// Render
	return (
		<Page.Section
			willGrow
			willCenter
			name="message">
			<NonIdealState
				icon="path-search"
				title={translate.local('fallback.title')}
				description={<code>{getFullPath()}</code>}
				action={
					<Button
						large
						intent={Intent.PRIMARY}
						icon="rocket-slant"
						style={{ marginTop: '2rem' }}
						onClick={() => navigate('/')}>
						{translate.global('actions.startOver')}
					</Button>
				} />
			</Page.Section>
	)
}

// Export
export default Message
